import { Injectable } from '@angular/core';
declare var $: any;

@Injectable({
    providedIn: 'root'
})
export class TableService {
    public language = {
        "sProcessing": "Processando...",
        "sLengthMenu": "Mostrar _MENU_ registros",
        "sZeroRecords": "Não foram encontrados resultados",
        "sInfo": "Mostrando de _START_ até _END_ de _TOTAL_ registros",
        "sInfoEmpty": "Mostrando de 0 até 0 de 0 registros",
        "sInfoFiltered": "",
        "sInfoPostFix": "",
        "sSearch": "Buscar:",
        "sUrl": "",
        "oPaginate": {
            "sFirst": "Primeiro",
            "sPrevious": "Anterior",
            "sNext": "Seguinte",
            "sLast": "Último"
        },
        select: {
            rows: " %d linha(s) selecionada(s)"
        }
    };

    constructor() { }

    async setup(id: string, dataTab: any) {

        try {
            if ($.fn.DataTable.isDataTable('#' + id)) {
                $('#' + id).DataTable().clear();
                $('#' + id).DataTable().destroy();
            }
            const cols = [];
            for (const e of dataTab[0]) {
                if (e === '') {
                    cols.push({
                        orderable: false,
                        targets: 0,
                        render(data, type, row, meta) {
                            if (type === 'display') {
                                // tslint:disable-next-line:max-line-length
                                data = '<div class="custom-control custom-checkbox"><input type="checkbox" id="label" class="custom-control-input dt-checkboxes"><label for="label" class="custom-control-label">&nbsp;</label></div>';
                            }
                            return data;
                        },
                        checkboxes: {
                            selectRow: true,
                            // tslint:disable-next-line:max-line-length
                            selectAllRender: '<div class="custom-control custom-checkbox"><input type="checkbox" id="label" class="custom-control-input dt-checkboxes"><label for="label" class="custom-control-label">&nbsp;</label></div>'
                        }
                    });
                } else {
                    cols.push({ orderable: true });
                }
            }
            return await $(`#${id}`).DataTable({
                data: dataTab,
                language: this.language,
                //   paginate: {
                //       previous: '<i class=\'mdi mdi-chevron-left\'>',
                //       next: '<i class=\'mdi mdi-chevron-right\'>'
                //   },
                //   info: 'Mostrando _START_ a _END_ de _TOTAL_',
                //   lengthMenu:
                //       'Mostrar <select class=\'custom-select custom-select-sm ml-1 mr-1\'>' +
                //       '<option value="5">5</option>' +
                //       '<option value="10">10</option>' +
                //       '<option value="20">20</option>' +
                //       '<option value="-1">Todos</option>' +
                //       '</select> contratos'
                // },
                pageLength: 10,
                select: {
                    style: 'multi'
                },
                columns: cols,
                drawCallback() {
                    $('.dataTables_paginate > .pagination').addClass(
                        'pagination-rounded'
                    );
                }
            });
        } catch (e) {
            return await $(`#${id}`).DataTable({
                language: this.language,
            });
        }
    }
}
